import {createApp} from 'vue'
import FormStepZero from './FormStepZero'

const el = '.kb-component--form-step-zero'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FormStepZeroDOM)=>{
            const component = createApp(FormStepZero).use(Store)
            component.mount(FormStepZeroDOM)
        })
    }
}